// Test IDs for rakia.io public site + admin dashboard.
// Naming: `<feature>-<element>` (kebab-case values).

export const NAV = {
  root: "site-nav",
  brand: "site-nav-brand",
  linkHome: "site-nav-link-home",
  linkAbout: "site-nav-link-about",
  linkSpeaking: "site-nav-link-speaking",
  linkAdvisory: "site-nav-link-advisory",
  linkWriting: "site-nav-link-writing",
  linkContact: "site-nav-link-contact",
  ctaWork: "site-nav-cta-work",
  mobileOpen: "mobile-nav-open-button",
  mobileClose: "mobile-nav-close-button",
  mobileOverlay: "mobile-nav-overlay",
  mobileLinkHome: "mobile-nav-link-home",
  mobileLinkAbout: "mobile-nav-link-about",
  mobileLinkSpeaking: "mobile-nav-link-speaking",
  mobileLinkAdvisory: "mobile-nav-link-advisory",
  mobileLinkWriting: "mobile-nav-link-writing",
  mobileLinkContact: "mobile-nav-link-contact",
};

export const HOME_PAGE = {
  root: "home-page",
  heroPrimaryCta: "home-hero-primary-cta-button",
  heroGhostCta: "home-hero-ghost-cta-button",
  proofBar: "proof-bar",
  statProducts: "proof-stat-products",
  statYears: "proof-stat-years",
  statSectors: "proof-stat-sectors",
  statMvp: "proof-stat-mvp",
  statCes: "proof-stat-ces",
  statClients: "proof-stat-clients",
  whatIdoCardCto: "what-i-do-card-cto",
  whatIdoCardSpeaking: "what-i-do-card-speaking",
  whatIdoCardCircle: "what-i-do-card-circle",
  closingCta: "home-closing-cta-button",
};

export const NEWSLETTER = {
  emailInput: "newsletter-email-input",
  submit: "newsletter-submit-button",
  success: "newsletter-success-message",
  error: "newsletter-error-message",
};

export const CONTACT_FORM = {
  root: "contact-form",
  nameInput: "contact-form-name-input",
  emailInput: "contact-form-email-input",
  subjectSelect: "contact-form-subject-select",
  messageTextarea: "contact-form-message-textarea",
  submit: "contact-form-submit-button",
  success: "contact-form-success-message",
  error: "contact-form-error-message",
};

export const SPEAKING_FORM = {
  root: "speaking-form",
  nameInput: "speaking-form-name-input",
  orgInput: "speaking-form-organization-input",
  eventInput: "speaking-form-event-input",
  formatSelect: "speaking-form-format-select",
  emailInput: "speaking-form-email-input",
  submit: "speaking-form-submit-button",
  success: "speaking-form-success-message",
  error: "speaking-form-error-message",
};

export const ADVISORY_FORM = {
  root: "advisory-form",
  nameInput: "advisory-form-name-input",
  companyInput: "advisory-form-company-input",
  typeSelect: "advisory-form-type-select",
  emailInput: "advisory-form-email-input",
  situationTextarea: "advisory-form-situation-textarea",
  submit: "advisory-form-submit-button",
  success: "advisory-form-success-message",
  error: "advisory-form-error-message",
};

export const ADMIN = {
  loginPasswordInput: "admin-login-password-input",
  loginSubmit: "admin-login-submit-button",
  loginError: "admin-login-error",
  tabs: "admin-dashboard-tabs",
  tabInquiries: "admin-tab-inquiries",
  tabArticles: "admin-tab-articles",
  tabPodcasts: "admin-tab-podcasts",
  tabImages: "admin-tab-images",
  inquiriesTable: "admin-inquiries-table",
  inquiriesFilter: "admin-inquiries-filter",
  articlesTable: "admin-articles-table",
  podcastsTable: "admin-podcasts-table",
  imagesGrid: "admin-images-grid",
  imageUploadInput: "admin-image-upload-input",
  imageResetButton: "admin-image-reset-button",
  newArticleBtn: "admin-new-article-button",
  newPodcastBtn: "admin-new-podcast-button",
  logoutBtn: "admin-logout-button",
};
